class StickyInitialScroll {
    constructor(element) {
        const self = this;
        self._element = element;
        self._isScrolled = false;
        // eventListener handler needs correct context and should be referenceable for the removeListener
        self._handleScrollInteraction = self._handleScrollInteraction.bind(
            self
        );
        self._removeInitialStateAfterScrollInteraction();
    }

    _handleScrollInteraction() {
        const self = this;
        if (self._isScrolled === false) {
            self._isScrolled = true;
            self._element.classList.remove("receipt--visually-hidden");
            window.removeEventListener(
                "scroll",
                self._handleScrollInteraction,
                false
            );
        }
    }

    _removeInitialStateAfterScrollInteraction() {
        const self = this;
        window.addEventListener("scroll", self._handleScrollInteraction, false);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    for (let element of document.querySelectorAll(
        ".receipt--visually-hidden"
    )) {
        new StickyInitialScroll(element);
        element.setAttribute("data-initialized", "");
    }
});
